import { type OralArgumentResult } from '../../types';
import { ResultsGrid, type ViewType } from '../shared';

import { OralArgumentsResultCard } from './OralArgumentsResultCard';

export interface OralArgumentsResultsProps {
  results: OralArgumentResult[];
  viewType?: ViewType;
}

export const OralArgumentsResults = ({
  results,
  viewType = 'grid',
}: OralArgumentsResultsProps) => (
  <ResultsGrid
    results={results}
    viewType={viewType}
    renderCard={(argumentItem) => (
      <OralArgumentsResultCard argumentItem={argumentItem} />
    )}
    getKey={(argumentItem, index) => argumentItem.id || index}
  />
);
